import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  ExecutionLogsParams,
  ExecutionLogsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  params?: ExecutionLogsParams
  children?: (data: ExecutionLogsResponse) => ReactElement
}

const GetAiExecutionLogsRequest = ({
  id,
  params,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/executions/${id}/logs`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      params={params}
      url={url}
    />
  )
}

export default GetAiExecutionLogsRequest
